import { ROUTE_CHECKOUT_SUCCESS, ROUTE_ONSITE_CHECKOUT } from 'navigation/config/routePaths';

const TECHNICAL_USER_ALLOWED_PATH_PREFIXES = [`${ROUTE_ONSITE_CHECKOUT}/`];
const TECHNICAL_USER_ALLOWED_PATHS = [ROUTE_CHECKOUT_SUCCESS];

export const isTechnicalUserAllowedPath = (pathname: string): boolean => {
  return (
    TECHNICAL_USER_ALLOWED_PATHS.includes(pathname) ||
    TECHNICAL_USER_ALLOWED_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix))
  );
};
